import { isDocustream } from "./helpers/core";

export { TOKEN_KEY, MFA_SESSION_KEY } from "@libertify/auth/core";
export const SELECTED_ORG_ID_KEY = "selectedOrganizationId";
export const PERSIST_STORE_KEY = "libertify.app.state";
export const DOCUSTREAM_BANNER_DISMISSED_KEY =
  "docustream-merge-banner-dismissed";
export const PENDING_AUTH_METHOD_KEY = "pending_auth_method";
export const API_URL = import.meta.env.VITE_API_BASE_URL || "";

export const ALL_WORKSPACES_ID = "__ALL__";

export const FUND_MAX_TICKER_LENGTH = 10;
export const CDN_URL = import.meta.env.VITE_CDN_URL || "";
export const CHATBOT_WS_URL = import.meta.env.VITE_CHATBOT_WS_URL || "";
export const NOTIFICATION_WS_URL =
  import.meta.env.VITE_NOTIFICATION_WS_URL || "";
export const STORYBOARD_WS_URL = import.meta.env.VITE_STORYBOARD_WS_URL || "";
export const HTTP_MAINTENANCE_STATUS = 503;
export const USER_INVITE_EXPIRY_DAYS = 7;
export const RECONNECT_BACKOFF_COUNT = 3;

let NEW_MEDIAPLAYER_URL = import.meta.env.VITE_MEDIAPLAYER_URL || "";
let NEW_EXPERIENCE_PERMALINK_DOMAIN: string =
  import.meta.env.VITE_EXPERIENCE_PERMALINK_DOMAIN || "";
if (isDocustream()) {
  NEW_MEDIAPLAYER_URL = NEW_MEDIAPLAYER_URL.replace(
    "libertify.com",
    "docustream.ai"
  );
  NEW_EXPERIENCE_PERMALINK_DOMAIN = NEW_EXPERIENCE_PERMALINK_DOMAIN.replace(
    "libertify.net",
    "docustream.live"
  ).replace("libertify.com", "docustream.ai");
}
export const MEDIAPLAYER_URL = NEW_MEDIAPLAYER_URL;
export const EXPERIENCE_PERMALINK_DOMAIN = NEW_EXPERIENCE_PERMALINK_DOMAIN;

export const HG_EDITOR_SCRIPT_URL =
  import.meta.env.VITE_HG_EDITOR_SCRIPT_URL || "http://localhost:3000";
export const HG_EDITOR_SCRIPT_NAME =
  import.meta.env.VITE_HG_EDITOR_SCRIPT_NAME || "editor.js";
export const HG_EDITOR_PREVIEW_SCRIPT_PATH =
  import.meta.env.VITE_HG_EDITOR_PREVIEW_SCRIPT_PATH || "/widget.js";

export enum FeatureFlags {
  StoryboardMetrics = "features.app.media.storyboard_metrics",
  ContactFaceless = "features.app.media.contact_faceless",
  ScaleKitAuth = "features.app.media.auth_scalekit",
  LibertifySocialAuth = "features.app.media.libertify_auth_social",
  CustomVideoResolution = "features.app.media.video.custom_resolution",
  MobileCloning = "features.app.media.mobile_cloning",
  HeyGeniusProject = "features.app.media.heygenius_project",
  DocHeyGenius = "features.app.media.heygenius_doc",
  ThemeEditor = "features.app.media.theme_editor",
  DarkMode = "features.app.dark_mode",
  NewProjectDetailLayout = "features.app.media.new_project_detail_layout",
  WorkspaceInvites = "features.app.media.workspace_invites",
  SubscriptionNoIframe = "features.app.media.subs_no_iframe",
  ShowFlashScriptEditor = "features.app.media.show_flash_script_editor",
  AddonsAnalytics = "features.app.media.addons_analytics",
}
export enum Configurations {
  UPLOAD_LIMIT = "admin.media.uploads.max_size.documents",
  SUPPORTED_LOCALES = "admin.media.supported_locales",
  PUBLIC_LIBRARY_FONT = "admin.media.assets.libraries.fonts",
  DEFAULT_PUBLIC_FONT_ID = "admin.media.assets.default_font_id",
  DOCUMENT_MIME_TYPES = "admin.media.document.mime_types",
  DOCUMENT_PRIMARY_MIME_TYPES = "admin.media.document.primary_mime_types",
}
export enum QuotaFeatures {
  ConcurrentMediaGeneration = "Libertify.Media.ConcurrentMediaGeneration",
  UserLicenseAssignment = "Libertify.Subscription.UserLicenseAssignment",
  Workspace = "Libertify.Workspace",
  MediaProject = "Libertify.Media.Project",
  ProjectPublication = "Libertify.Media.ProjectPublication",
}
// supported for i18n in the frontend
export const USER_LANGUAGES = ["en-US", "fr-FR", "es-ES"];

// hard limit to not overload backend
export const ANALYTICS_MAX_DATE_RANGE_MONTHS = 24;

export const MOUSE_BUTTON = {
  LEFT: 0,
  MIDDLE: 1,
  RIGHT: 2,
} as const;
